import React, { Fragment, useEffect, useState } from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTruckMoving } from '@fortawesome/free-solid-svg-icons'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import Header from '../Header/Header'

// route
import { withRouter } from 'react-router-dom'

// alert swal
import Swal from 'sweetalert2'

// services
import { getAllProveedores } from '../../Services/proveedorService'

// components
import ItemProveedorEliminado from './ItemProveedorEliminado'

const ProveedorEliminado = ({ history }) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const [isLoad, setIsLoad] = useState(true)
    const [proveedores, setProveedor] = useState([])

    // pagination
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        if (isLoad) {
            getAllProveedores(false, 0)
                .then((res) => {
                    setProveedor(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                })
                .catch((error) => console.log(error.response))
        } else {
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    const nextPage = () => {
        if (totalPage === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        if (page === totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllProveedores(false, page + 1)
            .then((res) => {
                setPage(page + 1)
                setProveedor(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error'))
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllProveedores(false, page - 1)
            .then((res) => {
                setPage(page - 1)
                setProveedor(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error'))
    }

    const handleBuscador = (e) => {
        if (e.key === 'Enter') {
            let data = e.target.value
            getAllProveedores(false, 0, data)
                .then((res) => {
                    setPage(0)
                    setProveedor(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                })
                .catch((err) => console.log('error'))
        }
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faTruckMoving}
                        title={'Proveedores Eliminados'}
                    />
                </div>

                <div className="bg-gris p-3">
                    <div className="d-flex bd-highlight">
                        <div className="p-2 flex-grow-1 bd-highlight">
                            <div className="input-group-prepend input-group-lg">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faSearch} />
                                </span>

                                <input
                                    type="text"
                                    className="form-control form-lg"
                                    id="inputNombre"
                                    name="precio"
                                    placeholder="Buscar"
                                    onKeyPress={(e) => handleBuscador(e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-row bd-highlight">
                        <div className="p-2 bd-highlight">
                            <button
                                className="btn btn-outline-info"
                                onClick={() => previousPage()}
                                aria-label="Previous"
                            >
                                <span aria-hidden="true">&laquo; Anterior</span>
                            </button>
                        </div>
                        <div className="p-2 bd-highlight mt-1">
                            Registros: {totalRegister} | Página actual:{' '}
                            {page + 1} | Total páginas : {totalPage}
                        </div>
                        <div className="p-2 bd-highlight">
                            <button
                                className="btn btn-outline-info"
                                onClick={() => nextPage()}
                                aria-label="Next"
                            >
                                <span aria-hidden="true">
                                    Siguiente &raquo;
                                </span>
                            </button>
                        </div>
                    </div>
                    <table className="table table-striped mt-3 text-center">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Telefono</th>
                                <th scope="col">Direccion</th>
                                <th scope="col">Correo</th>
                                <th scope="col">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {proveedores.map((proveedor) => (
                                <ItemProveedorEliminado
                                    key={parseInt(proveedor.id)}
                                    proveedor={proveedor}
                                    setIsLoad={setIsLoad}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(ProveedorEliminado)
